import React, { useEffect } from 'react';

import { useApp } from '../../context/AppContext';

import ContentToggle from '../../components/ContentToggle/ContentToggle';
import ProductList from '../../components/ProductList/ProductList';
import ProfileActions from '../../components/ProfileActions/ProfileActions';
import ProfileHeader from '../../components/ProfileHeader/ProfileHeader';
import StoriesContainer from '../../components/StoriesContainer/StoriesContainer';

import { colors } from '../../styles/colors';
import '../../App.css';

function Home() {
  const { appContent } = useApp();

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = colors.background.backend;
    window.Telegram.WebApp.BackButton.hide();
    window.Telegram.WebApp.setHeaderColor(colors.background.backend);
    return () => {
      document.querySelector('body').style.backgroundColor = colors.background.main;
    };
  }, []);

  return (
    <div className='container'>
      <ProfileHeader />
      <ProfileActions />
      {appContent?.stories?.length > 0 && <StoriesContainer />}
      <ContentToggle />
      <ProductList />
    </div>
  );
}

export default Home;
